import { TextField, MenuItem } from "@mui/material";
import { placeholderStyle } from "../Styles/VMStyles";
import { toTitleCase } from "../Util/UtilHelper";

function MUITextFieldSelect(props) {
  const {
    name,
    id,
    label,
    value,
    onChange,
    options = [],
    fullWidth = false,
    sx = {},
    placeholder = "Select",
    error,
    helperText,
    required,
    ...rest
  } = props;

  return (
    <TextField
      select
      name={name}
      id={id}
      label={label}
      value={value ?? ""}
      onChange={onChange}
      fullWidth={fullWidth}
      sx={sx}
      error={error}
      helperText={helperText}
      required={required}
      SelectProps={{
        displayEmpty: true,
        renderValue: (selected) => {
          const showPlaceholder = () => (
            <span style={{ color: "#9e9e9e", ...placeholderStyle }}>
              {toTitleCase(placeholder)}
            </span>
          );

          if (selected === null || selected === undefined || selected === "") {
            return showPlaceholder();
          }

          const opt = options.find(
            (o) => String(o.value) === String(selected)
          );

          // Options may still be loading — avoid showing raw ids
          if (!opt) {
            return showPlaceholder();
          }

          return opt.label;
        },
      }}
      style={fullWidth ? { minWidth: 0, width: "100%" } : { minWidth: "200px" }}
      {...rest}
    >

      <MenuItem value="" disabled>
        {toTitleCase(placeholder)}
      </MenuItem>

      {options.map((option) => (
        <MenuItem 
          key={option.id || option.value || option.label}  
          value={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default MUITextFieldSelect;
